import { ClassificationType } from "@/graphql/types/models";

export const ERROR_LABELS: Record<ClassificationType, string> = {
  [ClassificationType.CORRECT]: "Correct",
  [ClassificationType.NUMERIC_ERROR]: "Numeric Error",
  [ClassificationType.FORMATTING_ERROR]: "Formatting Error",
  [ClassificationType.MISSING_ERROR]: "Missing Error",
  [ClassificationType.PARTIAL_EXTRACTION]: "Partial Extraction",
  [ClassificationType.INCORRECT_EXTRACTION]: "Incorrect Extraction",
};

export const ERROR_COLORS: Record<
  ClassificationType,
  { bg: string; text: string; bar: string }
> = {
  [ClassificationType.CORRECT]: {
    bg: "bg-green-100",
    text: "text-green-800",
    bar: "bg-green-500",
  },
  [ClassificationType.NUMERIC_ERROR]: {
    bg: "bg-purple-100",
    text: "text-purple-800",
    bar: "bg-purple-500",
  },
  [ClassificationType.FORMATTING_ERROR]: {
    bg: "bg-blue-100",
    text: "text-blue-800",
    bar: "bg-blue-500",
  },
  [ClassificationType.MISSING_ERROR]: {
    bg: "bg-yellow-100",
    text: "text-yellow-800",
    bar: "bg-yellow-500",
  },
  [ClassificationType.PARTIAL_EXTRACTION]: {
    bg: "bg-orange-100",
    text: "text-orange-800",
    bar: "bg-orange-500",
  },
  [ClassificationType.INCORRECT_EXTRACTION]: {
    bg: "bg-red-100",
    text: "text-red-800",
    bar: "bg-red-500",
  },
};

export function getScoreColor(score: number): string {
  if (score >= 90) return "text-green-600";
  if (score >= 80) return "text-blue-600";
  if (score >= 70) return "text-yellow-600";
  if (score >= 60) return "text-orange-600";
  return "text-red-600";
}
